/**
 * Sensor type configuration for feed tanks
 * Used by AddFeedTankModal and ProvisionFeedTankModal
 */

import { FeedTankSensorTypeEnum } from "@/api";

export type SensorType = 'radar' | 'strain';

export const DEFAULT_SENSOR_TYPE: SensorType = 'strain';

export const SENSOR_OPTIONS: Array<{ value: SensorType; label: string }> = [
	{ value: 'strain', label: 'Strain' },
	{ value: 'radar', label: 'Radar' },
];

export function isRadar(sensorType: SensorType): boolean {
	return sensorType === FeedTankSensorTypeEnum.Radar;
}

export function isStrain(sensorType: SensorType): boolean {
	return sensorType === FeedTankSensorTypeEnum.Strain;
}
